import { Button, Group, Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { Personal } from "../Personal/Personal";
import { SolicitudesRuteo } from "./SolicitudesRuteo";

export const ACTCopiarRuta: EntityClientAction = {
    name: 'ACTCopiarRuta',
    label: 'Copiar Ruta',
    title: <Text fw={700}>Copiar Ruta</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: ['soru_brwDisponibleEnRutas'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const solicitudesruteo = entity as SolicitudesRuteo;
        const personal = new Personal(entity.API.client);

        const procParms = {
            c_personal_origen_id: selectedKeys?.[0]?.['c_personal_id'] ?? '',
            c_personal_destino_id: ''
        };

        let errores = '';

        if (!procParms.c_personal_origen_id) {
            errores = 'Los registros seleccionados son inválidos';
        }

        await modal.open({
            modalProps: {
                title: <Text fw="700">Copiar ruta</Text>,
                size: 'xl'
            },
            focusOnClosed: element,
            content: <LookupFormAction
                lookupEntity={personal}
                viewName={personal.def.views.perl_brwGestionPersonal.name}
                title="Copiar ruta"
                confirmContent="¿Está seguro de que desea copiar la ruta del personal seleccionado?"
                onActionFinished={async () => { if (onClose) await onClose(); }}
                onOK={
                    async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                        const abort_controller = new AbortController();
                        let status = 11;
                        let message = '';

                        if (keys && keys.length > 0) {
                            if (onClose) await onClose();
                            await modal.close();
                        }

                        procParms.c_personal_destino_id = keys![0].c_personal_id as string;
                        const result = await solicitudesruteo.API.executeProcess(solicitudesruteo.def.procs.soru_CrearSolicitudCopiar, procParms, abort_controller.signal);
                        status = result.Results[0].Status;
                        message = result.Results[0].Message;

                        if (status === 11) {
                            await modal.open({
                                modalProps: {
                                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                                },
                                focusOnClosed: element,
                                content:
                                    <>
                                        <Text size="sm" mb="xs">
                                            {message}
                                        </Text>
                                        <Group mt="xs" position="right">
                                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                                        </Group>
                                    </>
                            });
                        }

                        return result;
                    }
                }
            />

        });

        return false;
    }
}